import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58ba3b9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "patent-application" }

import { ref, onMounted, shallowRef, onUnmounted, computed, watch } from 'vue'
import * as echarts from 'echarts'
import { storeToRefs } from 'pinia'
import { useHomeDataStore } from '@/pinia/useHomeDataStore'
import TitleCpn from '../../../Title/TitleCpn.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'PatentApplication',
  setup(__props) {

const homeDataStore = useHomeDataStore()
const { data } = storeToRefs(homeDataStore)
const chartRef = ref()
const myChart = shallowRef()

const xAxisData = computed(() => {
    if (!data.value?.left3) {
        return []
    }
    return data.value.left3[0].xData
})

const legendData = computed<string[]>(() => {
    if (!data.value?.left3) {
        return []
    }
    return data.value.left3.map(item => item.name)
})

const series = computed(() => {
    if (!data.value?.left3) {
        return []
    }
    return data.value.left3.map(item => ({
        name: item.name,
        type: 'line',
        symbol: 'circle',
        sampling: 'lttb',
        label: {
            show: true,
            position: 'top',
            textStyle: {
                color: '#ffffff',
            }
        },
        lineStyle: {
            normal: {
                color: item.lineColor,
                shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 0,
                shadowOffsetY: 5,
                shadowOffsetX: 5,
            },
        },
        itemStyle: {
            color: "#ffffff",
            borderColor: item.lineColor,
            borderWidth: 1,
            shadowColor: 'rgba(0, 0, 0, .3)',
            shadowBlur: 0,
            shadowOffsetY: 2,
            shadowOffsetX: 2,
        },
        // areaStyle: {
        //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //         {
        //             offset: 0,
        //             color: item.areaColor.start
        //         },
        //         {
        //             offset: 1,
        //             color: item.areaColor.end
        //         }
        //     ])
        // },
        data: item.yDate
    }))
})

const option = computed(() => {
    return {
        legend: {
            show: true,
            data: legendData.value,
            align: 'right',
            top: 15,
            left: 40,
            textStyle: {
                color: '#ffffff',
                fontSize: '1.4rem'
            }
        },
        grid: {
            // width:315 //调整折线图的宽度
            top: 50,
            left: 40,
            right: 20,
            bottom: 30
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData.value,
            axisLabel: {
                show: true,
                textStyle: {
                    color: "#A2B0B8",
                    fontSize: '1.4rem'
                },
            }
        },
        yAxis: {
            axisTick: {
                show: false //轴刻度不显示
            },
            max: 'dataMax',
            type: 'value',
            boundaryGap: [0, '100%'],
            // 轴网格
            splitLine: {
                show: true,
                lineStyle: {
                    color: "#ffffff",
                    width: 0.3,
                    type: "dashed"
                }
            },
            //坐标轴文字样式
            axisLabel: {
                show: true,
                textStyle: {
                    color: "#A2B0B8",
                    fontSize: '1.4rem'
                }
            },
            axisLine: {
                lineStyle: {
                    width: 0
                }
            }
        },
        dataZoom: [
            {
                type: 'inside',
                start: 0,
                end: 100
            },
            {
                show: false,
                start: 0,
                end: 100
            }
        ],
        series: series.value
    }
})

onMounted(() => {
    createChart()
})

onMounted(() => {
    window.addEventListener('resize', handleResize)
})
onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
})

const handleResize = () => {
    myChart.value?.resize()
}

const createChart = async () => {
    myChart.value = echarts.init(chartRef.value);
    myChart.value.setOption(option.value)
}

watch(
    option,
    () => { myChart.value?.setOption(option.value) },
    {immediate: true}
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleCpn, { title: "专利申请趋势" }),
    _createElementVNode("div", {
      class: "chart-container",
      ref_key: "chartRef",
      ref: chartRef
    }, null, 512)
  ]))
}
}

})